export const TaxIntentOptions = {
  give_me_advice: { label: 'Give me advice', value: 'Give me advice' },
  file_for_me: { label: 'File a return for me', value: 'File a return for me' },
  tax_problem_resolution: {
    label: 'Resolve a tax problem',
    value: 'Resolve a tax problem'
  },
  other: { label: 'Other', value: 'Other' }
} as const;
